import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Tab,
} from "@chakra-ui/react";

import React from "react";

import CheckTable from "./components/CheckTable";
import PRCheckTable from "./components/PRCheckTable";

export default function UserReports() {
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const isAdmin = userInfo?.message?.isAdmin || false;
  return (
    <>
      {isAdmin ? (
        <Tabs
          colorScheme="messenger"
          pt={{ base: "180px", md: "80px", xl: "80px" }}
        >
          <TabList>
            <Tab border="transparent">Main Search</Tab>
            <Tab border="transparent">Product Search</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Box>
                <CheckTable />
              </Box>
            </TabPanel>
            <TabPanel>
              <Box>
                <PRCheckTable />
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <Box
          colorScheme="messenger"
          pt={{ base: "180px", md: "80px", xl: "80px" }}
        >
          <PRCheckTable />
        </Box>
      )}
    </>
  );
}
